import { render, staticRenderFns } from "./industryHealthJournalDetail.vue?vue&type=template&id=5872772a"
import script from "./industryHealthJournalDetail.vue?vue&type=script&lang=js"
export * from "./industryHealthJournalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5872772a')) {
      api.createRecord('5872772a', component.options)
    } else {
      api.reload('5872772a', component.options)
    }
    module.hot.accept("./industryHealthJournalDetail.vue?vue&type=template&id=5872772a", function () {
      api.rerender('5872772a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/ihj/industryHealthJournalDetail.vue"
export default component.exports